import { filterStyles } from "@insite/content-library/Widgets/MyLists/MyListsFilter";
import { css } from "styled-components";

// EC-755 : My List page : List filters layout
filterStyles.container = {
    css: css`
        padding-bottom: 15px;
        padding-top: 15px;
    `,
};
// EC-755 : My List page : List filters layout
